'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GenericIntent = function (_React$Component) {
  _inherits(GenericIntent, _React$Component);

  function GenericIntent(props) {
    _classCallCheck(this, GenericIntent);

    var _this = _possibleConstructorReturn(this, (GenericIntent.__proto__ || Object.getPrototypeOf(GenericIntent)).call(this, props));

    _this.handleChange = function (value) {
      _this.setState({ value: value });
    };

    _this.state = { value: 0 };
    return _this;
  }

  _createClass(GenericIntent, [{
    key: 'render',
    value: function render() {
      var classes = (0, _classnames2.default)('generic-intent', this.props.className);
      var ChildrenArray = _react2.default.Children.toArray(this.props.children);
      var Intent = _react2.default.cloneElement(ChildrenArray[0], { handleChange: this.handleChange });
      var Content = _react2.default.cloneElement(ChildrenArray[1], { value: this.state.value });

      return _react2.default.createElement(
        'section',
        { className: classes, id: this.props.id, 'data-building-block': 'organism' },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            Intent,
            Content
          )
        )
      );
    }
  }]);

  return GenericIntent;
}(_react2.default.Component);

exports.default = GenericIntent;


GenericIntent.propTypes = {
  id: _propTypes2.default.string,
  className: _propTypes2.default.string,
  children: _propTypes2.default.array.isRequired
};

GenericIntent.defaultProps = {
  className: '',
  id: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/generic-intent/jsx/GenericIntent.js
// module id = 678
// module chunks = 4